import { createModel } from '@rematch/core';

import type { TActionFrom } from 'infrastructure/interfaces/common';
import type { RootModel } from 'store/models';

export interface ConnectDetails {
  phone: string;
  guid: string;
  readingId: string;
  deviceId: string;
  isRpmCall?: boolean;
  actionFrom?: TActionFrom;
}

const connect = createModel<RootModel>()({
  state: {
    canCall: false,
    connectPopoutOpen: false,
    connectDetails: <ConnectDetails>{
      phone: '',
      guid: '',
      readingId: '',
      deviceId: '',
    },
  },
  reducers: {
    setConnectCanCall: (state, payload: boolean) => ({
      ...state,
      canCall: payload,
    }),
    setConnectPopoutOpen: (state, payload: boolean) => ({
      ...state,
      connectPopoutOpen: payload,
    }),
    setConnectDetails: (state, payload: ConnectDetails) => ({
      ...state,
      connectDetails: payload,
    }),
  },
  effects: (dispatch) => ({
    handleConnectPopoutOpen(status: boolean) {
      dispatch.connect.setConnectPopoutOpen(status);
    },
    connectDetails(details: ConnectDetails) {
      dispatch.connect.setConnectDetails(details);
    },
  }),
});

export default connect;
